"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @param {Array<{[key]: value}>} styles It's a map of {original_class: compiled_class}
 * @return {Function}
 */
var useStyles = function useStyles(styles) {
  if (Array.isArray(styles)) {
    styles = styles.reduce(function (acc, next) {
      return _objectSpread(_objectSpread({}, acc), next);
    });
  }
  /**
   * The function takes an argument then it's trying to find fit compiled class.
   * @param {string|Array<string>} styles It's a map of Array<{[original_class]: compiled_class}>
   * @return {Function<string>} Result: compiled class
   */


  return function (classNames) {
    var globalClassNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var result = null;
    if (!classNames) return '';

    if (Array.isArray(globalClassNames)) {
      globalClassNames = globalClassNames.join(' ');
    } else if (!globalClassNames) {
      globalClassNames = '';
    }

    if (Array.isArray(classNames)) {
      result = mapClassNames(classNames, styles);
    } else if (typeof classNames === 'string') {
      classNames = classNames.split(' '); // if multiple

      if (classNames.length > 1) {
        result = mapClassNames(classNames, styles);
      } else {
        result = styles[classNames] || withWarning(classNames);
      }
    }

    if (result) return "".concat(result, " ").concat(globalClassNames).trim();
    throw new Error('useStyles: Required selectors are not valid');
  };
};

var mapClassNames = function mapClassNames(classNames, styles) {
  return classNames.map(function (className) {
    return styles[className] || withWarning(className);
  }).filter(function (className) {
    return Boolean(className);
  }).join(' ');
};

var withWarning = function withWarning(className) {
  if (className !== null) {
    console.warn("useStyles: Class '".concat(className, "' wasn't find"));
  }

  return className;
};

var _default = useStyles;
exports["default"] = _default;